import { MentorServices } from "./service";
import {
  DELETE_MESSAGE_DATA,
  COHORT_REQUEST_STARTUP_DASHBOARD,
  DASHBOARD_STARTUP_MYREQUEST,
  DASHBOARD_STARTUP_HOME,
  ALL_STARTUP_LIST,
  MENTOR_REQUEST_MENTORS_LIST,
  STARTUP_APPLICATIONS,
  VIEW_COUNTER_STARTUP_OPTIONS,
  SESSIONS_SUMMARY_DATA,
  SESSIONS_SUMMARY_POST_DATA,
  SESSIONS_DELETE_DATA,
  UPLOAD_DOCUMENT,
  UPLOAD_DOCUMENT_LIST,
  POST_STARTUP_FEEDBACK,
  ENGAGEMENT_NOTES,
  UPLOAD_PROGRESS_REPORT,
  IM_SEND_MESSAGES,
  IM_ALL_MESSAGES,
  GET_STARTUP_FEEDBACK,
  SESSION_CALENDAR,
  GET_ENGAGEMENT_NOTES,
  MENTORSHIP_REQUESTS_COUNTER,
  NEW_MESSAGE_DISPLAY,
  MY_MENTORS_COUNTER,
  MY_STARTUPS_COUNTER,
  ALL_STARTUP_APPLICATION_LIST,
} from "../../../../common/constants/actionConstants";

import { isLoading } from "../../../../common/dependencies/action/action";

export const getCohortStartupList = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindDataList(params).then((data) => {
    const { getCohortRequest } = data;
    
    if (getCohortRequest) {
      dispatch({
        type: COHORT_REQUEST_STARTUP_DASHBOARD,
        payload: getCohortRequest,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindDataList(params) {
  const getCohortRequest = await MentorServices.getCohortRequest(params).catch(
    (e) => {
      return { data: [], status: false };
    }
  );
  return {
    getCohortRequest,
  };
}

export const getRequestfromMentorList = (params) => (dispatch) => {
  //
  dispatch(isLoading(true));
  return getBindData2(params).then((data) => {
    
    const { getRequestfromMentorList } = data;
    
    if (getRequestfromMentorList) {
      dispatch({
        type: MENTOR_REQUEST_MENTORS_LIST,
        payload: getRequestfromMentorList,
      });
    }
    dispatch(isLoading(false));
  });
};

async function getBindData2(params) {
  const getRequestfromMentorList =
    await MentorServices.getRequestfromMentorList(params).catch((e) => {
      return { data: [], status: false };
    });
  return { getRequestfromMentorList };
}
export const getStartupMyRequest = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindData(params).then((data) => {
    const { DashboardStartupMyRequestList } = data;
    if (DashboardStartupMyRequestList) {
      dispatch({
        type: DASHBOARD_STARTUP_MYREQUEST,
        payload: DashboardStartupMyRequestList,
      });
    }
    dispatch(isLoading(false));
  });
};

export const getStartupHome = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindDataStartupHomeList(params).then((data) => {
    const { DashboardStartupHomeList } = data;
    if (DashboardStartupHomeList) {
      dispatch({
        type: DASHBOARD_STARTUP_HOME,
        payload: DashboardStartupHomeList,
      });
    }
    dispatch(isLoading(false));
  });
};

export const getStartupList = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getStartUpListData(params).then((data) => {
    //
    const { getStartUpList } = data;
    if (getStartUpList) {
      dispatch({
        type: ALL_STARTUP_LIST,
        payload: getStartUpList,
      });
    }
    dispatch(isLoading(false));
  });
};

export const getStartupApplicationList = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getStartUpApplicationListData(params).then((data) => {
    //
    const { getStartUpapplicationList } = data;
    if (getStartUpapplicationList) {
      dispatch({
        type: ALL_STARTUP_APPLICATION_LIST,
        payload: getStartUpapplicationList,
      });
    }
    dispatch(isLoading(false));
  });
};

async function getStartUpApplicationListData(params) {
  const getStartUpapplicationList = await MentorServices.getStartUpapplicationList(params).catch(
    (e) => {
      return { data: [], status: false };
    }
  );
  return {
    getStartUpapplicationList,
  };
}


async function getStartUpListData(params) {
  const getStartUpList = await MentorServices.allStartUpList(params).catch(
    (e) => {
      return { data: [], status: false };
    }
  );
  return {
    getStartUpList,
  };
}

export const getSessionCalendar = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getSessionCalendarData(params).then((data) => {
    //
    const { getSessionCalendar } = data;
    if (getSessionCalendar) {
      dispatch({
        type: SESSION_CALENDAR,
        payload: getSessionCalendar,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getSessionCalendarData(params) {
  const getSessionCalendar = await MentorServices.AllSessionCalendar(
    params
  ).catch((e) => {
    return { data: [], status: false };
  });
  return {
    getSessionCalendar,
  };
}

export const getStartupApplication = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getStartUpApplicationData(params).then((data) => {
    
    const { getStartupApplication } = data;
    if (getStartupApplication) {
      dispatch({
        type: STARTUP_APPLICATIONS,
        payload: getStartupApplication,
      });
    }
    dispatch(isLoading(false));
  });
};

async function getStartUpApplicationData(params) {
  const getStartupApplication = await MentorServices.startUpApplication(
    params
  ).catch((e) => {
    return { data: [], status: false };
  });
  return {
    getStartupApplication,
  };
}
// export const getStartupList = () => (dispatch) => {
//   dispatch(isLoading(true));
//   return getBindDataStartupHomeList(params).then((data) => {
//     const { DashboardStartupHomeList } = data;
//     if (DashboardStartupHomeList) {
//       dispatch({
//         type: DASHBOARD_STARTUP_HOME,
//         payload: DashboardStartupHomeList,
//       });
//     }
//     dispatch(isLoading(false));
//   });
// };
async function getBindData(params) {
  const DashboardStartupMyRequestList =
    await MentorServices.dashboardStartupMyrequest().catch((e) => {
      return { data: [], status: false };
    });
  return { DashboardStartupMyRequestList };
}

async function getBindDataStartupHomeList(params) {
  if (params.id === "" || params.id === null) {
    // alert(params.id)
  } else {
    const DashboardStartupHomeList = await MentorServices.dashboardStartupHome(
      params
    ).catch((e) => {
      return { data: {}, status: false };
    });
    return { DashboardStartupHomeList };
  }
}
export const getCountersStartUpList = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindDataCountersStartUpList(params).then((data) => {
    const { getCountersStartUpList } = data;
    
    if (getCountersStartUpList) {
      dispatch({
        type: VIEW_COUNTER_STARTUP_OPTIONS,
        payload: getCountersStartUpList,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindDataCountersStartUpList(params) {
  const getCountersStartUpList =
    await MentorServices.getCountersStartUpList().catch((e) => {
      return { data: [], status: false };
    });
  return {
    getCountersStartUpList,
  };
}

export const getSessionSummaryData = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return getBindDataSessionSummary(params).then((data) => {
    const { getSummaryData } = data;
    
    if (getSummaryData) {
      dispatch({
        type: SESSIONS_SUMMARY_DATA,
        payload: getSummaryData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindDataSessionSummary(params) {
  const getSummaryData = await MentorServices.getSummaryData(params).catch(
    (e) => {
      return { data: [], status: false };
    }
  );
  return {
    getSummaryData,
  };
}
export const postSessionSummaryData = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindDataSessionSummary(params).then((data) => {
    const { postSummaryData } = data;
    
    if (postSummaryData) {
      dispatch({
        type: SESSIONS_SUMMARY_POST_DATA,
        payload: postSummaryData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindDataSessionSummary(params) {
  const postSummaryData = await MentorServices.postSummaryData(params).catch(
    (e) => {
      return { data: [], status: false };
    }
  );
  return {
    postSummaryData,
  };
}
export const deleteMessageData = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return deleteBindMessage(params).then((data) => {
    const { deleteMessageList } = data;
    
    if (deleteMessageList) {
      dispatch({
        type: DELETE_MESSAGE_DATA,
        payload: deleteMessageList,
      });
    }
    dispatch(isLoading(false));
  });
};
async function deleteBindMessage(params) {
  const deleteMessageList = await MentorServices.deleteMessagedataoflist(
    params
  ).catch((e) => {
    return { data: [], status: false };
  });
  return {
    deleteMessageList,
  };
}
export const deleteSessionData = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return deleteBindSession(params).then((data) => {
    const { deleteSessionList } = data;
    
    if (deleteSessionList) {
      dispatch({
        type: SESSIONS_DELETE_DATA,
        payload: deleteSessionList,
      });
    }
    dispatch(isLoading(false));
  });
};
async function deleteBindSession(params) {
  const deleteSessionList = await MentorServices.deleteSessionData(
    params
  ).catch((e) => {
    return { data: [], status: false };
  });
  return {
    deleteSessionList,
  };
}

export const postStartUpFeedback = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindStartUpFeedback(params).then((data) => {
    const { postStartUpFeedback } = data;
    
    if (postStartUpFeedback) {
      dispatch({
        type: POST_STARTUP_FEEDBACK,
        payload: postStartUpFeedback,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindStartUpFeedback(params) {
  const postStartUpFeedback = await MentorServices.postStartupFeedback(
    params
  ).catch((e) => {
    return { data: [], status: false };
  });
  return {
    postStartUpFeedback,
  };
}

export const getStartUpFeedback = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return getBindStartUpFeedback(params).then((data) => {
    const { getStartUpFeedback } = data;
    
    if (getStartUpFeedback) {
      dispatch({
        type: GET_STARTUP_FEEDBACK,
        payload: getStartUpFeedback,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindStartUpFeedback(params) {
  const getStartUpFeedback = await MentorServices.getStartupFeedback(
    params
  ).catch((e) => {
    return { data: [], status: false };
  });
  return {
    getStartUpFeedback,
  };
}
export const postUploadDocument = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindUploadDocument(params).then((data) => {
    const { postUploadDoc } = data;
    
    if (postUploadDoc) {
      dispatch({
        type: UPLOAD_DOCUMENT,
        payload: postUploadDoc,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindUploadDocument(params) {
  const postUploadDoc = await MentorServices.postUploadDocument(params).catch(
    (e) => {
      return { data: [], status: false };
    }
  );
  return {
    postUploadDoc,
  };
}

export const postEngagementNotes = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindEngagementNotes(params).then((data) => {
    const { postEngagementNotesData } = data;
    
    if (postEngagementNotesData) {
      dispatch({
        type: ENGAGEMENT_NOTES,
        payload: postEngagementNotesData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindEngagementNotes(params) {
  const postEngagementNotesData = await MentorServices.postEngagementNotes(
    params
  ).catch((e) => {
    return { data: [], status: false };
  });
  return {
    postEngagementNotesData,
  };
}
export const getEngagementNotes = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindGetEngagementNotes(params).then((data) => {
    const { getEngagementNotesData } = data;
    
    if (getEngagementNotesData) {
      dispatch({
        type: GET_ENGAGEMENT_NOTES,
        payload: getEngagementNotesData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindGetEngagementNotes(params) {
  const getEngagementNotesData = await MentorServices.getEngagementNotes(
    params
  ).catch((e) => {
    return { data: [], status: false };
  });
  return {
    getEngagementNotesData,
  };
}
export const postUploadProgressReport = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindUploadProgressReport(params).then((data) => {
    const { postUploadProgressReportData } = data;
    
    if (postUploadProgressReportData) {
      dispatch({
        type: UPLOAD_PROGRESS_REPORT,
        payload: postUploadProgressReportData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindUploadProgressReport(params) {
  const postUploadProgressReportData =
    await MentorServices.postProgressReport(params).catch((e) => {
      return { data: [], status: false };
    });
  return {
    postUploadProgressReportData,
  };
}
export const postSendMessageRequest = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return postBindSendMessageRequest(params).then((data) => {
    const { postSendMessageRequestData } = data;
    
    if (postSendMessageRequestData) {
      dispatch({
        type: IM_SEND_MESSAGES,
        payload: postSendMessageRequestData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function postBindSendMessageRequest(params) {
  const postSendMessageRequestData = await MentorServices.postSendImMessage(
    params
  ).catch((e) => {
    return { data: [], status: false };
  });
  return {
    postSendMessageRequestData,
  };
}
export const postAllMessageRequest = (params) => (dispatch) => {
  
  // dispatch(isLoading(true));
  return postBindAllMessageRequest(params).then((data) => {
    const { postAllMessageRequestData } = data;
    
    if (postAllMessageRequestData) {
      dispatch({
        type: IM_ALL_MESSAGES,
        payload: postAllMessageRequestData,
      });
    }
    // dispatch(isLoading(false));
  });
};
async function postBindAllMessageRequest(params) {
  
  const postAllMessageRequestData = await MentorServices.getAllImMessages(
    params
  ).catch((e) => {
    return { data: [], status: false };
  });
  return {
    postAllMessageRequestData,
  };
}
export const getUploadDocumentList = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return getBindUploadDocumentList(params).then((data) => {
    const { getUploadDoc } = data;
    
    if (getUploadDoc) {
      dispatch({
        type: UPLOAD_DOCUMENT_LIST,
        payload: getUploadDoc,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindUploadDocumentList(params) {
  const getUploadDoc = await MentorServices.getUploadDocumentList(params).catch(
    (e) => {
      return { data: [], status: false };
    }
  );
  return {
    getUploadDoc,
  };
}
export const getMyStartupsCounter = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return getBindMyStartupsCounter(params).then((data) => {
    const { myStartupsCountersData } = data;
    
    if (myStartupsCountersData) {
      dispatch({
        type: MY_STARTUPS_COUNTER,
        payload: myStartupsCountersData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindMyStartupsCounter(params) {
  const myStartupsCountersData = await MentorServices.getMyStartupCounter(params).catch(
    (e) => {
      return { data: [], status: false };
    }
  );
  return {
    myStartupsCountersData,
  };
}
export const getMyMentorsCounter = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return getBindMyMentorsCounter(params).then((data) => {
    const { myMentorsCountersData } = data;
    
    if (myMentorsCountersData) {
      dispatch({
        type: MY_MENTORS_COUNTER,
        payload: myMentorsCountersData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindMyMentorsCounter(params) {
  const myMentorsCountersData = await MentorServices.getMyMentorCounter(params).catch(
    (e) => {
      return { data: [], status: false };
    }
  );
  return {
    myMentorsCountersData,
  };
}
export const getStartupMentorshipCounter = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return getBindgetStartupMentorshipCounter(params).then((data) => {
    const { countersData } = data;
    
    if (countersData) {
      dispatch({
        type: MENTORSHIP_REQUESTS_COUNTER,
        payload: countersData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindgetStartupMentorshipCounter(params) {
  const countersData = await MentorServices.getStartUpMentorShip(params).catch(
    (e) => {
      return { data: [], status: false };
    }
  );
  return {
    countersData,
  };
}
export const getNewMessagesDash = (params) => (dispatch) => {
  
  dispatch(isLoading(true));
  return getBindNewMessagesDash(params).then((data) => {
    const { newMsgData } = data;
    
    if (newMsgData) {
      dispatch({
        type: NEW_MESSAGE_DISPLAY,
        payload: newMsgData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindNewMessagesDash(params) {
  const newMsgData = await MentorServices.getNewMessages(params).catch(
    (e) => {
      return { data: [], status: false };
    }
  );
  return {
    newMsgData,
  };
}
